class PromoBar extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
  }

  connectedCallback() {
    this.render();
    this.initSwiper();
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy();
      this.swiper = null;
    }
  }

  render() {
    const backgroundColorAttr = this.getAttribute('background-color') || '#fff';
    const textColorAttr = this.getAttribute('text-color') || '#0A0A0A';
    const slideContent = this.innerHTML;

    this.shadowRoot.innerHTML = `
      <style>
        :host {
          display: block;
          background-color: ${backgroundColorAttr};
          color: ${textColorAttr};
          overflow: hidden;
          padding: 1rem 0;
        }

        .swiper-wrapper {
          width: 100%;
          display: flex;
          align-items: center;
          height: 100%;
        }

        .swiper-slide {
          width: 100%;
          flex-shrink: 0;
          display: flex;
          justify-content: center;
          align-items: center;
          height: auto;
        }

        .promo-bar__content {
          color: inherit;
          text-align: center;
          font-family: "GT America";
          font-size: 12px;
          font-style: normal;
          font-weight: 300;
          line-height: 18px;

          padding: 0 1.6rem;
          display: flex;
          align-items: center;
          gap: 1rem;
        }

        .promo-bar__content p {
          width: 100%;
          color: inherit;
          margin: 0;
        }

        .promo-bar__content a {
          color: inherit;
          text-decoration: none;
        }
      </style>
      
      <div class="promo-bar">
        <div class="promo-swiper swiper-container">
          <div class="swiper-wrapper">
            ${slideContent}
          </div>
        </div>
      </div>
    `;
  }

  initSwiper() {
    // Check if Swiper is available
    if (typeof Swiper === 'undefined') {
      // Load Swiper dynamically if not available
      this.loadSwiper().then(() => {
        this.createSwiper();
      });
    } else {
      this.createSwiper();
    }
  }

  loadSwiper() {
    return new Promise((resolve, reject) => {
      // Load CSS
      const linkEl = document.createElement('link');
      linkEl.rel = 'stylesheet';
      linkEl.href = window.theme && window.theme.assets_url
        ? `${window.theme.assets_url}/swiper-bundle.min.css`
        : '/assets/swiper-bundle.min.css';
      linkEl.onload = () => {
        // After CSS is loaded, load JS
        const scriptEl = document.createElement('script');
        scriptEl.src = window.theme && window.theme.assets_url
          ? `${window.theme.assets_url}/swiper-bundle.min.js`
          : '/assets/swiper-bundle.min.js';
        scriptEl.onload = resolve;
        scriptEl.onerror = reject;
        document.head.appendChild(scriptEl);
      };
      linkEl.onerror = reject;
      document.head.appendChild(linkEl);
    });
  }

  createSwiper() {
    const delay = this.getAttribute('delay') || 1500;
    const swiperContainer = this.shadowRoot.querySelector('.promo-swiper');

    if (swiperContainer && typeof Swiper !== 'undefined') {
      this.swiper = new Swiper(swiperContainer, {
        loop: true,
        autoplay: {
          delay: delay,
          disableOnInteraction: false,
        },
        slidesPerView: 1,
        speed: 700,
      });
    }
  }
}

// Define the element
customElements.define('promo-bar', PromoBar); 